import $ from 'jquery';
import _ from 'lodash';
import Axios from "axios";
import ActionTypes from "./actionTypes";
import JsonApi from "./jsonApi";
import ProjectScope from "./components/projectScope/projectScope";
import StoneStore from './stores/stonesStore';
import Config from "./config";

module.exports = {
    loadServerData: function (jobId) {
        $(document).trigger(ActionTypes.SERVER_DATA_LOADING, {});

        function dataLoaded(response) {
            if (jobId) {
                if (Config.kioskStandAlone) {
                    Config.parent.window.app.db.tables.quoteStore.getQuoteStore(jobId, (results) => {
                        var data = JSON.parse(results.quoteData);
                        $(document).trigger(ActionTypes.SERVER_DATA_LOADED, {
                            stonesData: response[0].data,
                            newQuoteData: response[1].data,
                            jobData: data
                        });
                    });
                } else {
                    JsonApi.getJobData(jobId)
                        .then(function (jobDataResponse) {
                            $(document).trigger(ActionTypes.SERVER_DATA_LOADED, {
                                stonesData: response[0].data,
                                newQuoteData: response[1].data,
                                mainMenu: response[2].data,
                                jobData: jobDataResponse.data
                            });
                        });
                }
            } else {
                $(document).trigger(ActionTypes.SERVER_DATA_LOADED, {
                    stonesData: response[0].data,
                    newQuoteData: response[1].data,
                    mainMenu: Config.kioskStandAlone ? [] : response[2].data,
                    jobData: null
                });
            }
        }

        if (Config.kioskStandAlone) {
            Config.parent.window.app.db.tables.availableStones.getAvailableStone(Config.kvConfig.subdomain, function (stonesData) {
                Config.parent.window.app.db.tables.quoteData.getQuoteData(Config.kvConfig.subdomain, function (quoteData) {
                    dataLoaded([
                        {data: $.parseJSON(stonesData.json)},
                        {data: $.parseJSON(quoteData.json)}
                    ]);
                });
            });
        } else {
            const stonesPromise = JsonApi.allAvailableStones(jobId, '');
            const newQuoteDataPromise = JsonApi.getNewQuoteData(jobId, '');
            const mainMenuPromise = JsonApi.getMenuNavigation();
            Axios.all([stonesPromise, newQuoteDataPromise, mainMenuPromise])
                .then(dataLoaded);
        }
    },

    userLogin: function (email, password) {
        if (Config.kioskStandAlone) {
            Config.parent.window.app.db.tables.users.writeUser(email, password, null, null, null, null, null, Config.kvConfig.userId, Config.kvConfig.subdomain);
            $(document).trigger(ActionTypes.USER_LOGIN_ANSWER, {data: {email: email, password: password}});
        } else {
            JsonApi.userLogin(email, password)
                .then((response) => {
                    $(document).trigger(ActionTypes.USER_LOGIN_ANSWER, {data: response.data, password});
                });
        }
    },

    /***
     *
     * @param fullName
     * @param email
     * @param phoneNumber
     * @param zip
     * @param salesPersonFullName
     * @param salesPersonEmail
     */
    userRegister: function (fullName, email, phoneNumber, zip, salesPersonFullName, salesPersonEmail) {
        const data = {
            email: email,
            firstName: fullName,
            phone: phoneNumber,
            isNew: true,
            postal: zip,
            salesPersonFullName,
            salesPersonEmail,
            fabricatorId: Config.kvConfig.userId
        };
        ProjectScope.salesPerson.name = salesPersonFullName;
        ProjectScope.salesPerson.email = salesPersonEmail;

        if (Config.kioskStandAlone) {
            Config.parent.window.app.db.tables.users.writeUser(email, null, fullName, phoneNumber, zip, null, null, Config.kvConfig.userId, Config.kvConfig.subdomain);
            $(document).trigger(ActionTypes.USER_REGISTER_ANSWER, {data: data});
        } else {
            JsonApi.userRegister(data)
                .then(function (response) {
                    $(document).trigger(ActionTypes.USER_REGISTER_ANSWER, {data: response.data});
                });
        }
    },

    /**
     * Saves the current quote only, not all from current job. Make sure its called at the right time.
     */
    saveQuote: function (triggerEvent, submit) {
        ProjectScope.setUploadingQuote(true);

        const formData = new FormData();
        triggerEvent = triggerEvent === undefined ? false : triggerEvent;
        submit = submit === undefined ? false : submit;

        if (submit) {
            $(document).trigger(ActionTypes.QUOTE_BEFORE_SAVE, {});
        }

        let data = {
            submit: submit,
            jobId: ProjectScope.jobId,
            customerEmail: ProjectScope.userInfo().email,
            salesPerson: ProjectScope.salesPerson.name,
            salesPersonEmail: ProjectScope.salesPerson.email,
            fabricatorId: document.kvConfig.userId, // comes from back-end via an injected JS code
            isNewUser: ProjectScope.isNewUser,
            records: ProjectScope.quotes().map(function (q) {
                const features = [];
                _.each(q.features, function (quantity, featureId) {
                    features.push({
                        featureId: featureId,
                        quantity: quantity,
                        calculatedCost: q.featuresCost[featureId]
                    });
                });

                return {
                    quoteId: q.quoteId,
                    stoneId: q.stone.Id,
                    material: q.material,
                    stoneCost: q.stone ? _.first(q.stone.prices) : 0,
                    materialCost: q.materialPrice,
                    stoneSupplierStoneId: q.stoneSupplierStone ? q.stoneSupplierStone.Id : 0,
                    features: features,
                    sFtCalcDataJson: q.sFtCalcDataJson,
                    quoteTotal: q.totalPrice.toFixed(2)
                };
            }),
            notes: (ProjectScope.notes() || []).map(function (note) {
                return {
                    noteId: note.noteId || 0, // database ID
                    text: note.text,
                    title: note.title,
                    uid: note.uid
                };
            }),
            documents: (ProjectScope.documents() || []).map(function (d) {
                return {
                    documentId: d.documentId || 0, // database ID
                    name: d.name,
                    text: d.text,
                    created: d.created,
                    uid: d.uid,
                    fileContent: Config.kioskStandAlone ? d.file.dataUri : null
                };
            })
        };
        _.each(ProjectScope.documents(), function (doc) {
            if (!doc.uploaded) {
                formData.append("files", doc.file, doc.name);
            }
        });
        if (Config.kioskStandAlone) {
            //parent.window.app.db.tables.quotes.writeQuote(data);
            Config.parent.window.app.db.tables.quoteStore.writeQuoteStore(ProjectScope.jobId, document.kvConfig.subdomain, ProjectScope.userInfo().email, JSON.stringify(data), null, function (newJobId) {
                let idx = 0;
                _.each(ProjectScope.quotes(), function (quote) {
                    quote.quoteId = idx++;
                });
                ProjectScope.jobId = newJobId;

                data.jobId = newJobId;
                Config.parent.window.app.db.tables.quoteStore.writeQuoteStore(ProjectScope.jobId, document.kvConfig.subdomain, ProjectScope.userInfo().email, JSON.stringify(data), null);

                ProjectScope.setUploadingQuote(false);
                $(document).trigger(ActionTypes.QUOTE_SAVED, {data: data, submit: submit});

                if (triggerEvent) {
                    $(document).trigger(ActionTypes.DOCUMENTS_CHANGED, {});
                    $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
                }
            });
        } else {

            formData.append('json', JSON.stringify(data));
            JsonApi.saveQuote(formData)
                .then(function (response) {
                    data = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
                    if (!data.error) {
                        let idx = 0;
                        _.each(ProjectScope.quotes(), function (quote) {
                            quote.quoteId = data.quotesId[idx++];
                        });
                        ProjectScope.jobId = data.jobId;

                        idx = 0;
                        _.each(ProjectScope.notes(), function (note) {
                            note.noteId = data.notes[idx++].noteId;
                        });

                        idx = 0;
                        _.each(ProjectScope.documents(), function (document) {
                            document.documentId = data.documents[idx++].documentId;
                            document.uploaded = true;
                        });
                    }

                    ProjectScope.setUploadingQuote(false);
                    $(document).trigger(ActionTypes.QUOTE_SAVED, {data: data, submit: submit});

                    if (triggerEvent) {
                        $(document).trigger(ActionTypes.DOCUMENTS_CHANGED, {});
                        $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
                    }
                });
        }
        StoneStore.setUnsavedChanges(false);
    },

    resetUserPassword: function (email) {
        if (Config.kioskStandAlone) {
            //I don't think we need to really do anything here on kiosk mode
        } else {
            JsonApi.resetUserPassword(email)
                .then(function (response) {
                    $(document).trigger(ActionTypes.RESET_PASSWORD_ANSWER, {data: response.data});
                })
                .catch(e => {
                    $(document).trigger(ActionTypes.RESET_PASSWORD_ANSWER, {error: e.response.data.errors.join(',')});
                });
        }
    },

    scheduleCustomer: function (date, time, aptType) {
        const data = {
            jobId: ProjectScope.jobId,
            datePart: date,
            timePart: time,
            appointmentType: aptType === 'apt' ? 'Appointment' : 'Free Home Estimate'
        };

        if (Config.kioskStandAlone) {
            Config.parent.window.app.db.tables.schedules.writeSchedule(0, document.kvConfig.subdomain, JSON.stringify(data), null, function () {
                $(document).trigger(ActionTypes.SCHEDULE_COMPLETED, {data: data});
            });
        } else {
            JsonApi.scheduleCustomer(data)
                .then(function (response) {
                    $(document).trigger(ActionTypes.SCHEDULE_COMPLETED, {data: response.data});
                });
        }
    },
    getJobData: function (jobId) {
        if (Config.kioskStandAlone) {
            Config.parent.window.app.db.tables.quoteStore.getQuoteStore(jobId, (results) => {
                var data = JSON.parse(results.quoteData);
                $(document).trigger(ActionTypes.RECEIVED_JOB_DATA, {data: data});
            });
        } else {
            JsonApi.getJobData(jobId)
                .then(function (response) {
                    $(document).trigger(ActionTypes.RECEIVED_JOB_DATA, {data: response.data});
                });
        }
    },
    generateAuthenticationToken: function () {
        return JsonApi.generateAuthenticationToken();
    },
    sendAuthenticationRequest: function (token, to, type) {
        return JsonApi.sendAuthenticationRequest(token, to, type);
    },
    validateAuthenticationRequest: function (token, code, phoneNumber) {
        return JsonApi.validateAuthenticationRequest(token, code, phoneNumber);
    }
};




// WEBPACK FOOTER //
// ./src/middleware.js